import React from "react";
import "../../css/insightsView.css";
import "../../css/insightsOneView.css";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import Link from "gatsby-link";
import Modal from "../../components/Modal";
import { insightsConstants } from "../../constant/insights_constants";
import { DropdownButton, MenuItem } from "react-bootstrap";
import { ClipLoader } from "react-spinners";
import $ from "jquery";
import MediaQuery from "react-responsive";
import "animate.css/animate.min.css";
import ScrollAnimation from "react-animate-on-scroll";
import ReactPlayer from "react-player";
import emailForwardIcon from "../../images/icons/send-mail-icon.jpg";
import MailForwardForm from "../../components/MailForwardForm";

const icon1 = "https://winpeforum.com/assets/elements/sushma.jpg";

const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal
      direction=""
      className="teamdetails__wrapper"
      show={show}
      onHide={onHide}
      style={{ margin: "0% auto 0px" }}
    >
      <Modal.Header>
        <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
          <div className="item_des">{activeItem.post}</div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="item__desc">
          <div dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};
TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
};

export class SushmaKaushik extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      activeItem: {},
      isShow: false,
      activeKeyword: "",
      isSearching: false,
      lastCounter: 3,
      activeTitle: "SORT BY",
      activeSortBy: "default",
      showMailShareForm: false,
    };
    this.betterContent = insightsConstants;
    this.TabContent = [
      // {
      // 	title: "POPULARITY",
      // },
      {
        title: "ALL",
      },
      {
        title: "BLOGS",
      },
      {
        title: "INFOGRAPHICS",
      },
      {
        title: "INTERVIEWS",
      },
      {
        title: "VIDEOS",
      },
    ];
    this.Speaker = [
      {
        desc: `<div>Sushma is a Partner at Aavishkaar Capital and brings with her over 18 years of diverse experience in the field of early stage investing, small business incubation and consulting across sectors. Sushma has worked to identify, manage and exit large number of companies and has worked closely with several inclusive business entrepreneurs. She has been an active representative on the Boards of several early-growth stage companies. She started off with an entrepreneurial venture in engineering design services and moved on to roles in investments. She was part of the acquisition team at Starwood Capital where she evaluated diverse real estate assets. While at  Ashoka- Innovators for the Public, Sushma got to work with social entrepreneurs in the Housing for All initiative. She has worked closely on building collaborative partnerships in market based solutions for the low-income populations. <br/><br/>

        Sushma has completed a strategic leadership program at the prestigious Harvard Business School. She is an engineering graduate from RVCE, Bangalore and has an MBA from the Indian School of Business, Hyderabad.<br/><br/>
           
        Sushma loves solving problems and in her free time mentors startups across diverse fields. She was recognized as “40 UNDER 40” Alternate investment professional in India and as one of the Top 100 Women in Finance-2020 in the “leading” category.
        
        
        
        </div>`,
        name: "Sushma Kaushik",
        post: "Partner, Aavishkaar Capital ",
        imgUrl: icon1,
        head: "The Venturous Investor",
      },
    ];
  }
  componentDidMount() {
    // function sticky_relocate () {
    // 	var window_top = $(window).scrollTop()
    // 	var div_top = $("#sticky-anchor").offset().top
    // 	if (window_top > div_top) {
    // 		$("#sticky").addClass("stick")
    // 	} else {
    // 		$("#sticky").removeClass("stick")
    // 	}
    // }
    // $(function () {
    // 	$(window).scroll(sticky_relocate)
    // 	sticky_relocate()
    // })
  }

  toggleMailShareForm = () => {
    this.setState({ showMailShareForm: !this.state.showMailShareForm });
  };

  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {},
    });
  };
  handleMenu = (item) => {
    this.setState({
      activeTitle: item.title,
    });

    let leftlist = [...insightsConstants];
    this.betterContent = [];
    if (item.title === "SORT BY") {
      []
        .concat(leftlist)
        // .filter((a) => a.r_type === "Appetizer")
        .forEach((item, i) => this.betterContent.push(item));
    } else if (item.title === "ALL") {
      []
        .concat(leftlist)
        // .filter((a) => a.r_type === "Appetizer")
        .forEach((item, i) => this.betterContent.push(item));
    } else {
      []
        .concat(leftlist)
        .filter((insight) => {
          console.log(insight);
          // a.typee.indexOf(item.title) >= 0}
          let flag = false;
          for (let i = 0; i < insight.itype.length; i++) {
            if (item.title === insight.itype[i]) {
              flag = true;
            }
          }
          return flag;
        })
        .forEach((item, i) => this.betterContent.push(item));
    }
    this.setState({
      activeSortBy: item.title,
    });
    setTimeout(() => {
      this.setState({
        isSearching: false,
      });
    }, 1000);
  };
  handleSearch = (e) => {
    let str = e.target.value.length ? e.target.value.toLowerCase().trim() : "";
    this.setState({
      isSearching: true,
      activeKeyword: str,
    });
    let leftlist = [...insightsConstants];
    this.betterContent = [];
    leftlist.forEach((item) => {
      if (
        item.skey
          .toLowerCase()
          .trim()
          .search(str) > -1
      ) {
        this.betterContent.push(item);
      }
    });
    setTimeout(() => {
      this.setState({
        isSearching: false,
      });
    }, 1000);
  };
  render() {
    const leftList = this.betterContent.filter(
      (item) => item.url !== "/SushmaKaushik"
    );

    const {
      defaultStyle,
      isSearching,
      isShow,
      activeTitle,
      activeSortBy,
    } = this.state;
    const { location } = this.props;
    return (
      <div>
        <MailForwardForm
          show={this.state.showMailShareForm}
          onClickClose={this.toggleMailShareForm}
          url={"insights.php/forward"}
          insight="The Venturous Investor"
        />
        <ContentPage>
          <Meta
            title="Winpe Insights | The Venturous Investor"
            image={
              "https://winpeforum.com/assets/elements/sushma-thumb.jpg"
            }
            description="Sushma Kaushik is a well known face of impact investing in India. A risk taker who journeyed through industrial engineering and real estate private equity before finding her long term passion as an impact investor, Sushma talks about her unconventional career path, the evolution of impact investing and building sustainable companies with solid foundations. Read as Sushma busts some common myths on impact investing and shares her advice for young women investors and entrepreneurs."
            location={location}
            keywords=""
          />
          <Meta
            title="Winpe Insights | The Venturous Investor"
            image={
              "https://winpeforum.com/assets/elements/sushma-thumb.jpg"
            }
            description="Sushma Kaushik is a well known face of impact investing in India. A risk taker who journeyed through industrial engineering and real estate private equity before finding her long term passion as an impact investor, Sushma talks about her unconventional career path, the evolution of impact investing and building sustainable companies with solid foundations. Read as Sushma busts some common myths on impact investing and shares her advice for young women investors and entrepreneurs.  
            "
            location={location}
            keywords=""
          />
          <div className="section__content">
            <div className="insights_wrapper">
              <div className="insights_section">
                <MediaQuery query="(min-width: 768px)">
                  <div className="insights_main_heading">
                    <div className="left_line"></div>
                    <div className="insights_main_heading_text">
                      Winpe INSIGHTS
                    </div>
                  </div>
                </MediaQuery>
                <MediaQuery
                  query="(min-width: 767px)"
                  style={{ display: "none" }}
                >
                  <div className="insights_main_heading"></div>
                </MediaQuery>
                <div className="insights_content">
                  <div className="drop_src_box">
                    <MediaQuery query="(min-width: 768px)">
                      <div className="left_drop_box">
                        <DropdownButton title={activeTitle}>
                          {this.TabContent.map((item, j) => {
                            return (
                              <MenuItem
                                onClick={() => this.handleMenu(item)}
                                activeSortBy={activeSortBy}
                                text={item.title}
                                key={j}
                              >
                                {item.title}
                              </MenuItem>
                            );
                          })}
                        </DropdownButton>
                      </div>
                    </MediaQuery>
                    <MediaQuery
                      query="(max-width: 767px)"
                      style={{ display: "none" }}
                    >
                      <div className="left_drop_box">
                        <DropdownButton title={activeTitle}>
                          {this.TabContent.map((item, j) => {
                            return (
                              <MenuItem
                                onClick={() => this.handleMenu(item)}
                                activeSortBy={activeSortBy}
                                text={item.title}
                                key={j}
                              >
                                {item.title}
                              </MenuItem>
                            );
                          })}
                        </DropdownButton>
                      </div>
                    </MediaQuery>
                    <MediaQuery query="(min-width: 768px)">
                      <div className="left_scr_box">
                        <form id="demo-2">
                          <input
                            type="search"
                            placeholder="Search"
                            onChange={(e) => this.handleSearch(e)}
                            value={this.state.activeKeyword}
                          />
                        </form>
                      </div>
                    </MediaQuery>
                    <MediaQuery
                      query="(max-width: 767px)"
                      style={{ display: "none" }}
                    >
                      <div className="left_scr_box"></div>
                    </MediaQuery>
                  </div>
                  <div className="insights_mid_section">
                    <div className="row">
                      <MediaQuery query="(min-width: 768px)">
                        <div className="col-lg-3 col-md-3">
                          <div id="sticky-anchor"></div>
                          <div className="insights_left_listing">
                            <div className="insights_left_listing_text">
                              <div className="left_listing_card left_listing_card--feature">
                                <div className="listing_t1">
                                  <span>Interview&nbsp;</span>
                                  &#8226; 18 June 2021
                                </div>
                                <div className="listing_t2">
                                The Venturous Investor
                                </div>
                                <div className="listing_t3">
                                Sushma Kaushik of Aavishkaar Capital 
                                </div>
                              </div>
                              <div className="left_listing_card--feature__el1"></div>
                              {isSearching ? (
                                <div style={{ margin: "10% 25% 10%" }}>
                                  <ClipLoader
                                    color={"#22316B"}
                                    loading={isSearching}
                                  />
                                </div>
                              ) : leftList.length ? (
                                leftList.slice(0, 27).map((item, i) => {
                                  return (
                                    <div className="left_listing_card" key={i}>
                                      <Link
                                        to={`/insights/${item.url.replace(
                                          /[^A-Z0-9]+/gi,
                                          ""
                                        )}`}
                                      >
                                        <div className="listing_t1">
                                          <span>{item.type}&nbsp;</span>
                                          &#8226; {item.date}
                                        </div>
                                        <div className="listing_t2">
                                          {item.ltitle}
                                        </div>
                                        <div className="listing_t3">
                                          {item.lname}
                                        </div>
                                      </Link>
                                    </div>
                                  );
                                })
                              ) : (
                                <div className="no__product">
                                  Not available in the list
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </MediaQuery>
                      <MediaQuery
                        query="(max-width: 767px)"
                        style={{ display: "none" }}
                      >
                        <div className="col-lg-3 col-md-3">
                          <div id="sticky-anchor"></div>
                          <div className="insights_left_listing"></div>
                        </div>
                      </MediaQuery>
                      <div className="col-lg-9 col-md-9">
                        <ScrollAnimation
                          delay={0}
                          duration={2}
                          animateIn="slideInRight"
                          offset={600}
                        >
                          <div className="insights_right_text">
                            <div className="insights_blog_page">
                              <div className="back_event">
                                <Link to="/insights">
                                  <i className="fa fa-arrow-left">
                                    {" "}
                                    browse Insights
                                  </i>
                                </Link>
                              </div>
                              <div className="insights_blog_text">
                                {this.Speaker.map((item, i) => {
                                  return (
                                    <div className="row">
                                      <ScrollAnimation
                                        delay={0}
                                        duration={1}
                                        animateIn="zoomIn"
                                        offset={100}
                                      >
                                        <div className="col-md-5 col-sm-6">
                                          <div
                                            className="right_img_section"
                                            onClick={() =>
                                              this.togglePopUp(item)
                                            }
                                          >
                                            <img
                                              src={item.imgUrl}
                                              alt="sushma kaushik"
                                              className="img-responsive"
                                            />
                                          </div>
                                        </div>
                                        <div className="col-md-7 col-sm-6">
                                          <div className="right_name_section">
                                            <div className="r_head">
                                              {item.head}
                                            </div>
                                            <div className="r_name">
                                              {item.name}
                                            </div>
                                            <div className="r_post">
                                              Partner, Aavishkaar Capital 
                                             
                                            </div>
                                            <div className="r_block">
                                              <span>INTERVIEW</span> &#8226; 6
                                              mins read
                                            </div>
                                          </div>
                                          <div className="share_section_one">
                                            <div className="headsocialLink">
                                              <span className="hicon">
                                                <a
                                                  href={`https://www.facebook.com/sharer/sharer.php?u=https://winpeforum.com${location.pathname}`}
                                                  target="_blank"
                                                  className=""
                                                  style={{
                                                    display: "block !important",
                                                  }}
                                                >
                                                  <img
                                                    src="https://winpeforum.com/assets/elements/SM_icon_01_new.png"
                                                    alt=""
                                                  />
                                                </a>
                                              </span>
                                              <span className="hicon">
                                                <a
                                                  style={{
                                                    display: "block !important",
                                                  }}
                                                  href={`https://twitter.com/intent/tweet?url=https://winpeforum.com${location.pathname}`}
                                                  target="_blank"
                                                  className=""
                                                >
                                                  <img
                                                    src="https://winpeforum.com/assets/elements/SM_icon_02_new.png"
                                                    alt=""
                                                  />
                                                </a>
                                              </span>
                                              <span className="hicon">
                                                <a
                                                  style={{
                                                    display: "block !important",
                                                  }}
                                                  href={`https://www.linkedin.com/sharing/share-offsite/?url=https://winpeforum.com${location.pathname}`}
                                                  target="_blank"
                                                  className=""
                                                >
                                                  <img
                                                    src="https://winpeforum.com/assets/elements/social_Media_icon_03_new_new.png"
                                                    alt=""
                                                  />
                                                </a>
                                              </span>
                                              <span className="hicon">
                                                <button
                                                  style={{
                                                    display: "block !important",
                                                    width: "25px",
                                                  }}
                                                  className="forwardMail"
                                                  title="Forward to email"
                                                  onClick={
                                                    this.toggleMailShareForm
                                                  }
                                                >
                                                  <img
                                                    src={emailForwardIcon}
                                                    alt=""
                                                  />
                                                </button>
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </ScrollAnimation>
                                    </div>
                                  );
                                })}
                              </div>
                              <div className="insights_blog_text_btm">
                                <div className="text_section">
                                  <div className="into_text">
                                  Sushma Kaushik is a well known face of impact investing in India. A risk taker who journeyed through industrial engineering and real estate private equity before finding her long term passion as an impact investor, Sushma talks about her unconventional career path, the evolution of impact investing and building sustainable companies with solid foundations. Read as Sushma busts some common myths on impact investing and shares her advice for young women investors and entrepreneurs.


                                  </div>
                                  <div className="interview_vieo_section">
                                    <div className="interview_video">
                                      <div className="into_text">
                                        “I see impact investing transitioning to v3.0. Now, digitization is becoming an equalizer and technology and innovation are solving for large complex problems like health, education, jobs /livelihood creation etc. and more importantly we are observing very high quality entrepreneurial talent with exceptional technology experience solving for India’s unique problems.”<br/><br/>
                                      </div>
                                     
                                    </div>
                                  </div>
                                  <div className="r_text_Q">
                                  Q1. You have worked as an entrepreneur, in consulting and in real estate before joining Aavishkaar where you have now spent more than a decade. Please tell us about your journey and how you went about your decisions and career choices. 
                                  </div>
                                  <div className="r_text">
                                  I am an engineering graduate who completed my bachelor’s degree during the period of the famed Dot com bust (2001). And just like most Indian engineering students of that era I graduated with two jobs from campus, but (fortunately) both those got deferred. I could have taken the easy way out like most of my batch-mates did and opt to study abroad, but that wasn’t something that excited me. I realized I had a strong bias for action and so decided to dive head first into entrepreneurship in the Engineering Services for Real Estate Assets. Four years of sourcing business grounds up, handling clients, paying salaries, ensuring cashflows etc. can be the most humbling experience and I would encourage more youngsters to try that out at some point. Entrepreneurship tests the grit and mettle of any individual, and for me it was baptism by fire. 4 years hence, I decided, it was time to explore larger avenues and so sold the business and went on to complete my MBA from ISB Hyderabad (2007). <br/><br/>
                                  Because of my Real Estate operating experience in my previous venture, I managed to get one of the few “buy side” jobs in a Real Estate PE fund. Back in 2006-2007 there were very few active PE funds in India, so I guess I was lucky to bag a job in one.   <br/> <br/>
                                  Working at Starwood Capital (a global RE PE fund) gave me the experience and rigor required in investing. It also exposed me to working across cross-cultural teams. Those were interesting times when we didn’t have the luxury of rich data bases and had to build investing cases based on ground level research.      <br/>
                                  Around that time, the start-up ecosystem in India was in its fledgling days and I was keen to work with entrepreneurs again. The VC ecosystem was also evolving and Aavishkaar Capital was one of the most active (micro) VC funds (c USD 32mn) in the Impact space (2010) and I liked what they were building. Impact investing as a theme was emerging and I was keen to participate in that journey and so approached them. As they say, rest is history. <br/> <br/>
                                  Today, the global impact investing market is at USD 715bn. In India alone, impact investing manages assets of >USD 2.7bn. With the awareness in this asset class improving, ESG-focused funds are expected to have over USD 50 trillion of assets by 2025. Currently Aavishkaar Capital manages ~ USD 400mn in AUM with investments across ~60 companies in India and South Asia and is looking to expand further in India and Africa. We are now on our 6th India focussed multi-stage fund targeting a USD 200+mn fund size.     <br/> <br/>
                                  Now when I look back, I realize that I always followed my heart and at the core, I am a risk taker, so I was not afraid of venturing out of my comfort zone to explore uncharted waters. Whether it was pursuing entrepreneurship or RE investing or Impact investing. The other motivating factor for me has been building things grounds up and that’s why start-up investing excites me.<br/><br/>
                                  </div>
                                  <div className="r_text_Q">
                                  Q2. The field of impact investing has seen significant changes and evolution in recent years, with different terms and strategies coming to associate with it. What is your take on impact investing?
                                  </div>
                                  <div className="r_text">
                                  Incidentally, the term “Impact Investing” was first coined in 2007, but that doesn’t mean that impact investing didn’t exist before that. In the previous avatar, impact investing was “Impact First” which was seen as an extension of philanthropy. <br/> <br/>

                                    Impact investing v1.0 saw capital supporting entrepreneurs solving for grass root level problems. The challenge in that was “scale” or rather “lack of scale”. These were businesses that were great local enterprises, creating jobs and livelihoods at local level, but didn’t achieve the right outcomes for investors. <br/> <br/>

                                    Then came Impact Investing v2.0 with the introduction of commercial microfinance institutions. Emergence of this solved a complex social problem of financial inclusion being addressed at a large scale level, yielding great impact and commercial return outcomes for investors. <br/> <br/>

                                    I see impact investing transitioning to v3.0. Now, digitization is becoming an equalizer and technology and innovation are solving for large complex problems like health, education, jobs /livelihood creation etc. and more importantly we are observing very high quality entrepreneurial talent with exceptional technology experience solving for India’s unique problems. This is the main game changer in the impact investing space. Capital flowing into such enterprises is achieving the dual outcome of impact and returns.  <br/> <br/>

                                    The Risk-Return trade-off is specific to Asset Classes, Themes, Stage of investing, type of investing (Buy-out vs. minority) etc. As an asset manager, Returns depend on the fund strategy one has set out to achieve. As a commercial mutli-stage impact investor, Aavishkaar Capitals objective has been to generate commercial returns while focusing on amplifying Impact outcomes. Aavishkaar Capital’s latest fund’s performance is in the top-quartile of funds of that vintage , hence QED!                 <br/> <br/>


                                </div>
                                <div className="r_text_Q">
                                  Q3. With responsible investing, ESG reporting and impact measurement becoming increasingly accepted amongst the “commercial” funds, lines are blurring. How do impact investors, especially the ones that seek to balance impact with financial rigour, differentiate themselves?
                                  </div>
                                  <div className="r_text">
                                  It’s great to see the evolution of Impact investing from a side-line asset class it was in 2007 to becoming a mainstream asset class today. In-fact this is the much needed shift from the “Greed is Good” model that we are all taught in a capitalistic society, and probably we required a pandemic to recognize the importance of being “Responsible Investors” focussing on sustainability. As investors we need to be conscious of our society and environment while executing on our fiduciary duties. So the first step we are observing in this direction is the approach taken towards measurement of impact with ESG reporting guidelines. <br/> <br/>

                                However, impact investing requires a deeper level of consciousness of balancing Impact outcomes along with commercial outcomes. This goes beyond just measurement. As impact investors, it is important to set the right foundation in building high quality enterprises that last long. Some of the impact interventions an impact investor is able to bring about become ingrained in the culture of the company early on and is difficult to replicate as a bolt-on strategy later. For example, ensuring diversity and inclusion (D&I) practices at every level (Board, leadership and employment) of an organization takes a generational shift, if incorporated late in the life of a business.  However, if it is incorporated during the formative years of the company, it becomes a way of life.  <br/> <br/>

                                As businesses grow, the importance of focusing on sustainability in long term value creation is becoming more important. Ignoring the impact of the business on both the environment and the society can be detrimental to any industry. It can cause serious supply chain disruptions, multi-stakeholder problems, customer displeasure, and now investor backlash. Impact investors have an important role to play while partnering with other Investors.    <br/> <br/>   

                                      </div>
                                 <div className="r_text_Q">
                                  Q4. Some say gender is the next ESG and some who believe gender and diversity is about impact. Donning the hat of a female partner at an impact investing firm, where do you think gender sits and where do you see it evolving from here?
                                  </div>
                                  <div className="r_text">
                                  Diversity and Inclusion, even beyond gender, should be what we should all try and achieve as a society. One of the Sustainable Development Goals is to achieve an equitable society. At Aavishkaar Group, we have committed to become a Gender Neutral (which goes beyond achieving gender equality) work place by 2030. This is quite an audacious goal to achieve and we have started working in that direction.  <br/> <br/>
                                    In an ideal world, gender shouldn’t even be a topic of discussion and yet it’s the elephant in the room with the multiple cultural biases around this topic. This will continue to be a problem that will take a generational shift to correct, but I am hopeful of seeing change in the right direction as more women come into the work force and become empowered.  <br/> <br/>

                                    People are always eager to slot things into buckets as that’s how mental models work. Gender equitability could be a measurable impact and so can very well fall under ESG. I believe, it doesn’t matter where it sits, as long as we can achieve the desired outcome.     <br/> <br/>   

                                </div>
                                <div className="r_text_Q">
                                  Q5. Is gender a focus at Aavishkaar? Please share the efforts that Aavishkaar is making in this area.
                                  </div>
                                  <div className="r_text">
                                  Aavishkaar Capital is an equal opportunity employer. 50% of the Investing team are men and they are there only based on merit :) . So while we had not consciously worked on it, that’s how it turned out. The result of having a balanced team, is that we try and neutralize biases. Even investing decisions are taken in a more balanced approach. At Aavishkaar Capital, we have ~60 investments and have created >47,000 jobs and 276,763 livelihoods  and the key beneficiaries are women. As a team we put in efforts to drive change in our portfolio companies to a) build awareness and b) promote gender balance.          <br/> <br/>   
                                 </div>
                                 <div className="r_text_Q">
                                  Q6. Busting myths related to impact investing:
                                  </div>
                                  <div className="r_text">

                                 <ul> <li>	<b><i>Impact investing = no/ low returns </i></b><br/>    
Depends on the objective of the impact investor. Commercial impact investors like Aavishkaar Capital strive to achieve commercial outcomes while creating impact.
 </li>
 <li>	<b><i> Women are better impact investors</i></b> <br/>   
Women tend to be more conscious investors.
</li>
<li><b><i>	Impact is created by small companies, investing in large companies does not create impact </i></b><br/>   
Large companies have the advantage of creating a 10x multiplier on impact, provided they are driven with the purpose of impact. Hence, an impact investor has an important role to play as companies scale.
</li>
<li><b><i>	Impact funds are small funds</i></b> <br/>   
Impact funds need to be present across the continuum of funds, early stage – growth stage- capital markets – secondary funds, in-order to preserve impact.<br/>  <br/>  
</li>
</ul> 
                                  </div>
                                  <div className="r_text_Q">
                                  Q7. Advice for young women investors and entrepreneurs, in a single sentence:
                                  </div>
                                  <div className="r_text">

                                 <ul> <li>	<b><i> 	Building your brand </i></b><br/>    
                                 It’s one of the most important brands worth investing in! </li>
 <li>	<b><i>Dealing with being the only woman in the room </i></b> <br/>   
 Get used to the attention.
</li>
<li><b><i> Finding that work-life balance   </i></b><br/>   
Prioritize life and balance will fall into place.
</li>
<li><b><i> Handling being stereotyped or feeling discriminated </i></b> <br/>   
Own that feeling and use it to power forward, also know which battles to fight and when.
</li>
<li><b><i> Dealing with fund raising biases  </i></b> <br/>   
Things are slowly changing for the better, so keep persevering.  <br/>  <br/>  
</li>
</ul> 
                                  </div>
                                  <div className="r_text_Q">
                                  Q8. Tell us more about Sushma:
                                  </div>
                                  <div className="r_text">

                                 <ul> <li>	<b><i>  Favorite quote/ life motto  </i></b><br/>    
                                 When life gives you lemons, enjoy the lemonade!</li>
 <li>	<b><i> 	Leadership mantra  </i></b> <br/>   
 Be the change you want to see.
</li>
<li><b><i> Milestone closest to your heart    </i></b><br/>   
I am grateful to every milestone that has got me this far… 
</li>
<li><b><i> 	An unpleasant incident that taught you a valuable lesson  </i></b> <br/>   
This pandemic has taught me an important lesson- Life is too short, be kind and inspire people, because that’s what people will remember you for!
</li>
<li><b><i>  What drives you   </i></b> <br/>   
The quest for a good problem to solve.  
</li>
<li><b><i>   Your stress buster   </i></b> <br/>   
Hiking.  <br/>  <br/>  
</li>
</ul> 
                                  </div>
                                  <div className="r_text_Q"></div>
                                  <div className="r_text_Q"></div>
                                  {/* <div className="r_text">
                                    <div
                                      className="para"
                                      style={{ padding: "20px 0px 0px 0px" }}
                                    >
                                      <i>Interviewed by Sreeja Vasantham</i>
                                    </div>
                                  </div> */}
                                </div>
                                <div className="footer_sm_icon">
                                  <div className="headsocialLink">
                                    <span className="hicon">
                                      <a
                                        href={`https://www.facebook.com/sharer/sharer.php?u=https://winpeforum.com${location.pathname}`}
                                        target="_blank"
                                        className=""
                                        style={{ display: "block !important" }}
                                      >
                                        <img
                                          src="https://winpeforum.com/assets/elements/SM_icon_01_new.png"
                                          alt=""
                                        />
                                      </a>
                                    </span>
                                    <span className="hicon">
                                      <a
                                        style={{ display: "block !important" }}
                                        href={`https://twitter.com/intent/tweet?url=https://winpeforum.com${location.pathname}`}
                                        target="_blank"
                                        className=""
                                      >
                                        <img
                                          src="https://winpeforum.com/assets/elements/SM_icon_02_new.png"
                                          alt=""
                                        />
                                      </a>
                                    </span>
                                    <span className="hicon">
                                      <a
                                        style={{ display: "block !important" }}
                                        href={`https://www.linkedin.com/sharing/share-offsite/?url=https://winpeforum.com${location.pathname}`}
                                        target="_blank"
                                        className=""
                                      >
                                        <img
                                          src="https://winpeforum.com/assets/elements/social_Media_icon_03_new_new.png"
                                          alt=""
                                        />
                                      </a>
                                    </span>
                                    <span className="hicon">
                                      <button
                                        style={{
                                          display: "block !important",
                                          width: "25px",
                                        }}
                                        className="forwardMail"
                                        title="Forward to email"
                                        onClick={this.toggleMailShareForm}
                                      >
                                        <img src={emailForwardIcon} alt="" />
                                      </button>
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="back_event">
                                <Link to="/insights">
                                  <i className="fa fa-arrow-left">
                                    {" "}
                                    browse Insights
                                  </i>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </ScrollAnimation>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <TeamModal
                show={isShow}
                onHide={this.togglePopUp}
                activeItem={this.state.activeItem}
              />
            </div>
          </div>
        </ContentPage>
      </div>
    );
  }
}
SushmaKaushik.propTypes = {
  location: PropTypes.object,
};

export default SushmaKaushik;



// WEBPACK FOOTER //
// ./src/pages/insights/SushmaKaushik.js